const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadLogoFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 392.78125 144.820312 L 392.78125 444.847656 C 392.78125 474.898438 368.417969 499.261719 338.367188 499.261719 L 67.277344 499.261719 C 37.226562 499.261719 12.863281 474.898438 12.863281 444.847656 L 12.863281 67.152344 C 12.863281 37.101562 37.226562 12.738281 67.277344 12.738281 L 267.007812 12.738281 L 267.007812 102.894531 C 267.007812 126.144531 285.804688 144.941406 309.054688 144.941406 L 392.78125 144.941406 Z M 392.78125 144.820312 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fillOpacity: 1
    },
    fill: "#ff9e00",
    "data-original": "#00acea",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 267.007812 12.738281 L 392.78125 144.945312 L 309.054688 144.945312 C 285.804688 144.945312 267.007812 126.144531 267.007812 102.894531 Z M 267.007812 12.738281 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fillOpacity: 1
    },
    fill: "#fdedd3",
    "data-original": "#00efd1",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 275.910156 3.957031 C 273.5625 1.484375 270.347656 0 267.007812 0 L 67.277344 0 C 30.421875 0 0 30.300781 0 67.152344 L 0 444.847656 C 0 481.699219 30.421875 512 67.277344 512 L 338.367188 512 C 375.21875 512 405.640625 481.699219 405.640625 444.847656 L 405.640625 144.820312 C 405.640625 141.605469 404.15625 138.511719 402.054688 136.164062 Z M 279.5 43.65625 L 363.964844 132.328125 L 309.054688 132.328125 C 292.730469 132.328125 279.5 119.21875 279.5 102.769531 Z M 338.367188 487.265625 L 67.277344 487.265625 C 44.152344 487.265625 24.734375 468.097656 24.734375 444.847656 L 24.734375 67.152344 C 24.734375 44.027344 44.027344 24.734375 67.277344 24.734375 L 254.765625 24.734375 L 254.765625 102.769531 C 254.765625 132.824219 279.003906 157.0625 309.054688 157.0625 L 380.910156 157.0625 L 380.910156 444.847656 C 380.910156 468.097656 361.617188 487.265625 338.367188 487.265625 Z M 338.367188 487.265625 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fillOpacity: 1
    },
    fill: "#000000",
    "data-original": "#083863",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 304.601562 401.933594 L 101.039062 401.933594 C 94.238281 401.933594 88.671875 407.496094 88.671875 414.300781 C 88.671875 421.101562 94.238281 426.667969 101.039062 426.667969 L 304.726562 426.667969 C 311.527344 426.667969 317.09375 421.101562 317.09375 414.300781 C 317.09375 407.496094 311.527344 401.933594 304.601562 401.933594 Z M 304.601562 401.933594 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fillOpacity: 1
    },
    fill: "#000000",
    "data-original": "#083863",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 139.5 268.863281 L 190.453125 214.074219 L 190.453125 349.125 C 190.453125 355.925781 196.019531 361.492188 202.820312 361.492188 C 209.625 361.492188 215.191406 355.925781 215.191406 349.125 L 215.191406 214.074219 L 266.140625 268.863281 C 268.617188 271.460938 271.832031 272.820312 275.167969 272.820312 C 278.136719 272.820312 281.230469 271.707031 283.578125 269.480469 C 288.527344 264.78125 288.898438 256.988281 284.199219 252.042969 L 211.851562 174.253906 C 209.5 171.78125 206.285156 170.296875 202.820312 170.296875 C 199.359375 170.296875 196.144531 171.78125 193.792969 174.253906 L 121.445312 252.042969 C 116.746094 256.988281 117.117188 264.90625 122.066406 269.480469 C 127.011719 274.179688 134.800781 273.808594 139.5 268.863281 Z M 139.5 268.863281 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fillOpacity: 1
    },
    fill: "#000000",
    "data-original": "#083863",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadLogoFileIcon);
export default __webpack_public_path__ + "static/media/upload-logo-file-icon.d87ea1df3a0ff86120005af2b7254ec0.svg";
export { ForwardRef as ReactComponent };